import Heading1 from './Heading1';
export default Heading1;
